import React, { useEffect, useState } from 'react';
import { Button, Card, CardBody, Collapse } from 'reactstrap';
import api from '../../../../helpers/api';
import langText from '../../../../utils/langText';
import CompanyBody from './CompanyBody';
const CompanyList = () => {
  const [companyData, setCompanyData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen1, setIsOpen1] = useState(false);

  const toggle = () => setIsOpen(!isOpen);
  const toggle1 = () => setIsOpen1(!isOpen1);

  useEffect(() => {
    getCompanies();
  }, []);
  const getCompanies = async () => {
    try {
      const result = await api.get('/job/supplier-artisans-with-jobs');
      setCompanyData(result.data);
    } catch (error) {
      console.log(error);
    }
  };
  console.log(companyData, 'companyData');
  return (
    <div className='d-flex flex-column'>
      <h1>الشركات</h1>
      <Button color='primary' onClick={toggle} style={{ marginBottom: '1rem' }}>
        الحرفيين
      </Button>
      <Collapse isOpen={isOpen}>
        <div className='row'>
          {companyData?.artisans?.map(data => {
            return (
              <React.Fragment key={data._id}>
                <CompanyBody data={data} />
              </React.Fragment>
            );
          })}
        </div>
      </Collapse>
      <Button
        color='primary'
        onClick={toggle1}
        style={{ marginBottom: '1rem' }}
      >
        الياقات الزرقاء
      </Button>
      <Collapse isOpen={isOpen1}>
        <div className='row'>
          {companyData?.suppliers?.map(data => {
            return (
              <React.Fragment key={data._id}>
                <CompanyBody data={data} />
              </React.Fragment>
            );
          })}
        </div>
      </Collapse>
    </div>
  );
};

export default CompanyList;
